import { Version } from "../../../types/version";
import { EntitySelectionProps } from "../EntitySelectionInput";
import EntitySelectionModal from "../../modals/EntitySelectionModal";
import useVersionQuery from "../../../hooks/query/useVersionQuery";
import useVersionLogic from "../../../hooks/logic/versionLogic";

interface VersionSelectionModalProps extends EntitySelectionProps<Version> {
  systemLanguageType: Version["system_language_type"];
}

export const VersionSelectionModal: React.FC<VersionSelectionModalProps> = ({
  open,
  initialSelectedEntity,
  onClose,
  handleEntitySelect,
  systemLanguageType,
  required,
}) => {
  const { useFetchAll } = useVersionQuery(systemLanguageType);
  const { languageBasedColumns } = useVersionLogic(systemLanguageType);
  const { data, isLoading, pagination, setPagination, errorMessage } =
    useFetchAll({
      filters: { system_language_type: systemLanguageType },
      enabled: open,
    });

  return (
    <EntitySelectionModal
      open={open}
      onClose={onClose}
      title="Select Versions"
      columns={languageBasedColumns}
      data={data?.data || []}
      error={errorMessage}
      loading={isLoading}
      pagination={pagination}
      onPaginationChange={setPagination}
      onSelect={handleEntitySelect}
      totalRowCount={data?.total || 0}
      initialSelectedEntity={initialSelectedEntity}
      required={required}
    />
  );
};

const renderVersionSelection =
  (systemLanguageType: Version["system_language_type"]) =>
  (props: EntitySelectionProps<Version>) => (
    <VersionSelectionModal {...props} systemLanguageType={systemLanguageType} />
  );

export default renderVersionSelection;
